module.exports = __webpack_public_path__ + "img/memberKit.a975769b.svg";